import React from "react"
import RichTextRenderer from "../richTextRenderer"
import "./index.scss"

const PrivacyPolicyContent = ({ policies, title }) => {
  return (
    <section className="privacy-policy-content-section section-container container-padding section-margin">
      <div>
        <h1>{title}</h1>
      </div>
      <RichTextRenderer content={policies.raw} />
    </section>
  )
}

export default PrivacyPolicyContent
